import { render, staticRenderFns } from "./AdditionalEmergencyContacts.vue?vue&type=template&id=2bb5a7f9&scoped=true&"
import script from "./AdditionalEmergencyContacts.vue?vue&type=script&lang=js&"
export * from "./AdditionalEmergencyContacts.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalEmergencyContacts.vue?vue&type=style&index=0&id=2bb5a7f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5a7f9",
  null
  
)

export default component.exports